import CpPalette from './CpPalette';

export default {
  __init__: ['CpPalette'],
  CpPalette: ['type', CpPalette]
};
